import { render, staticRenderFns } from "./BasicInfoTaskBlock.vue?vue&type=template&id=1265d4f4&"
import script from "./BasicInfoTaskBlock.vue?vue&type=script&lang=js&"
export * from "./BasicInfoTaskBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports